import { BUNDLE_OFFERS_DATA_FETCH, BUNDLE_OFFERS_PENDING_STATUS_FETCH } from '@/redux/reducers/responsive/actionsTypes';
import { getBundleDetails } from "@/services/productServices";
import { ThunkResult } from '@/models/common/core/ThunkResult';
import { BUNDLE_OFFERS_DATA_FETCH_TYPE, BUNDLE_OFFERS_PENDING_STATUS_FETCH_TYPE } from './promotionalOffersType';

export const fetchBundleOffersListData = (bundleId: string): ThunkResult<BUNDLE_OFFERS_DATA_FETCH_TYPE> => (dispatch) => {
    dispatch(updatePromotionalOffersPendingStatusAction(true));
    getBundleDetails(bundleId)
        .then(response => {
            dispatch({
                type: BUNDLE_OFFERS_DATA_FETCH,
                payload: {
                    bundleOffers: response.data
                }
            })
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(()=> {
            dispatch(updatePromotionalOffersPendingStatusAction(false));
        })
}

export const updatePromotionalOffersPendingStatusAction = (isLoading: boolean): ThunkResult<BUNDLE_OFFERS_PENDING_STATUS_FETCH_TYPE> => {
    return function (dispatch) {
        dispatch({
            type: BUNDLE_OFFERS_PENDING_STATUS_FETCH,
            payload: {
                isLoading,
            },
        });
    }
}
